/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;align-items:center}.list-left[_ngcontent-%COMP%]{padding-right:0;margin-right:1rem}.grey-text[_ngcontent-%COMP%]{font-size:12px}a[_ngcontent-%COMP%]{cursor:default}"];
export { styles as styles };
